export const ZERO_STATE_SESSION_STORAGE_FLAG = 'select-zero-state-template';
export const ONBOARDING_MODE = {
  ONBOARDING: 'ONBOARDING',
  NO_ONBOARDING: 'NO_ONBOARDING'
};
export const ZERO_STATE_TEMPLATES = [{
  illustration: 'operations-custom-mappings',
  name: ONBOARDING_MODE.ONBOARDING,
  i18nKey: 'dashboard.zeroState.tour.createFreeForm.onboardingMode.helpMeGetStarted',
  creationType: 'onboarding'
}, {
  illustration: 'pencil',
  name: ONBOARDING_MODE.NO_ONBOARDING,
  i18nKey: 'dashboard.zeroState.tour.createFreeForm.onboardingMode.noHelpRequired',
  creationType: 'firstLaunch'
}];